import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { useEmpresasContext } from '../context/EmpresasContext';
import { Card } from '../components/ui';
import { useTranslation } from 'react-i18next';

// ===============================
// ICONOS PARA CADA SECCIÓN
// ===============================

const MachinesIcon = () => (
  <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
    <path d="M3.375 4.5C2.339 4.5 1.5 5.34 1.5 6.375V13.5h12V6.375c0-1.036-.84-1.875-1.875-1.875h-8.25ZM13.5 15h-12v2.625c0 1.035.84 1.875 1.875 1.875h.375a3 3 0 1 1 6 0h3a.75.75 0 0 0 .75-.75V15Z" />
    <path d="M8.25 19.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0ZM15.75 6.75a.75.75 0 0 0-.75.75v11.25c0 .087.015.17.042.248a3 3 0 0 1 5.958.464c.853-.175 1.522-.935 1.464-1.883a18.659 18.659 0 0 0-3.732-10.104 1.837 1.837 0 0 0-1.47-.725H15.75Z" />
    <path d="M19.5 19.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0Z" />
  </svg>
);

const OperadoresIcon = () => (
  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
  </svg>
);

const FaenasIcon = () => (
  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2-2v2m8 0H8m8 0v2a2 2 0 01-2 2H10a2 2 0 01-2-2V6" />
  </svg>
);

const PrediosIcon = () => (
  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 21v-4m0 0V5a2 2 0 012-2h6.5l1 1H21l-3 6 3 6h-8.5l-1-1H5a2 2 0 00-2 2zm9-13.5V9" />
  </svg>
);

const RodalesIcon = () => (
  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7" />
  </svg>
);

const InsumosIcon = () => (
  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
  </svg>
);

const ProveedoresIcon = () => (
  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />
  </svg>
);

const VehiculosIcon = () => (
  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 17h14M5 17a2 2 0 100 4 2 2 0 000-4zm14 0a2 2 0 100 4 2 2 0 000-4zM5 17V9a2 2 0 012-2h7l3 4h1a2 2 0 012 2v4M5 9h9" />
  </svg>
);

const TarjetasIcon = () => (
  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
  </svg>
);

const EmisoresIcon = () => (
  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
  </svg>
);

const ItemsChequeoIcon = () => (
  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4" />
  </svg>
);

const CalificadoresIcon = () => (
  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z" />
  </svg>
);

const UsuariosMaquinasIcon = () => (
  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z" />
  </svg>
);

const ConfiguracionIcon = () => (
  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
  </svg>
);

const UsuariosOperadoresIcon = () => (
  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
  </svg>
);

// ===============================
// COMPONENTE DE CARD ADMIN
// ===============================

interface AdminCardProps {
  title: string;
  description: string;
  icon: React.ReactNode;
  isAvailable: boolean;
  onClick?: () => void;
}

const AdminCard: React.FC<AdminCardProps> = ({
  title,
  description,
  icon,
  isAvailable,
  onClick
}) => {
  const { t } = useTranslation();
  return (
    <Card 
      className={`hover:shadow-lg transition-all duration-200 cursor-pointer ${
        isAvailable 
          ? 'border-blue-200 hover:border-blue-300' 
          : 'border-gray-200 opacity-60 cursor-not-allowed'
      }`}
      onClick={isAvailable ? onClick : undefined}
      padding="lg"
    >
      <div className="flex items-start space-x-4">
        <div className={`p-3 rounded-lg ${
          isAvailable 
            ? 'bg-blue-100 text-blue-600' 
            : 'bg-gray-100 text-gray-400'
        }`}>
          {icon}
        </div>
        <div className="flex-1">
          <h3 className={`text-lg font-semibold ${
            isAvailable ? 'text-gray-900' : 'text-gray-500'
          }`}>
            {title}
          </h3>
          <p className={`text-sm mt-1 ${
            isAvailable ? 'text-gray-600' : 'text-gray-400'
          }`}>
            {description}
          </p>
          {!isAvailable && (
            <p className="text-xs text-red-500 mt-2">
              {t('errors.forbidden')}
            </p>
          )}
        </div>
        {isAvailable && (
          <div className="text-blue-500">
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </div>
        )}
      </div>
    </Card>
  );
};

// ===============================
// COMPONENTE PRINCIPAL
// ===============================

export const AdminView: React.FC = () => {
  const { hasPermission, hasAnyPermission } = useAuth();
  const { estadisticas } = useEmpresasContext();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const canAccessMaquinas = hasAnyPermission(['maquinas.ver', 'maquinas.administrar']);
  const canAccessOperadores = hasAnyPermission(['operadores.ver', 'operadores.administrar']);
  const canAccessFaenas = hasPermission('faenas.ver');
  const canAccessCalificadores = hasPermission('faenas.ver');
  const canAccessPredios = hasPermission('predios.ver');
  const canAccessRodales = hasPermission('rodales.ver');
  const canAccessInsumos = hasPermission('insumos.ver');
  const canAccessProveedores = hasPermission('proveedores.ver');
  const canAccessVehiculos = hasPermission('vehiculos.ver');
  const canAccessTarjetas = hasPermission('tarjetas.ver');
  const canAccessEmisores = hasPermission('emisores.ver');
  const canAccessItemsChequeo = hasPermission('items_chequeo.ver');
  const canAccessUserControlMaquinas = hasPermission('maquinas.administrar');
  const canAccessUserControlOperadores = hasPermission('operadores.administrar');
  const canAccessConfiguracion = hasPermission('sistema.administrar');

  const adminSections = useMemo(() => [
    {
      id: 'maquinas',
      title: t('admin.machines'),
      description: t('admin.machines_desc'),
      icon: <MachinesIcon />,
      isAvailable: canAccessMaquinas,
      onClick: () => navigate('/admin/maquinas')
    },
    {
      id: 'operadores',
      title: t('admin.operators'),
      description: t('admin.operators_desc'),
      icon: <OperadoresIcon />,
      isAvailable: canAccessOperadores,
      onClick: () => navigate('/admin/operadores')
    },
    {
      id: 'faenas',
      title: t('admin.faenas'),
      description: t('admin.faenas_desc'),
      icon: <FaenasIcon />,
      isAvailable: canAccessFaenas,
      onClick: () => navigate('/admin/faenas')
    },
    {
      id: 'calificadores',
      title: t('admin.qualifiers'),
      description: t('admin.qualifiers_desc'),
      icon: <CalificadoresIcon />,
      isAvailable: canAccessCalificadores,
      onClick: () => navigate('/admin/calificadores')
    },
    {
      id: 'predios',
      title: t('admin.predios'),
      description: t('admin.predios_desc'),
      icon: <PrediosIcon />,
      isAvailable: canAccessPredios,
      onClick: () => navigate('/admin/predios')
    },
    {
      id: 'rodales',
      title: t('admin.rodales'),
      description: t('admin.rodales_desc'),
      icon: <RodalesIcon />,
      isAvailable: canAccessRodales,
      onClick: () => navigate('/admin/rodales')
    },
    {
      id: 'insumos',
      title: t('admin.supplies'),
      description: t('admin.supplies_desc'),
      icon: <InsumosIcon />,
      isAvailable: canAccessInsumos,
      onClick: () => navigate('/admin/insumos')
    },
    {
      id: 'proveedores',
      title: 'Proveedores',
      description: 'Proveedores de combustible (estaciones de servicio)',
      icon: <ProveedoresIcon />,
      isAvailable: canAccessProveedores,
      onClick: () => navigate('/admin/proveedores')
    },
    {
      id: 'vehiculos',
      title: 'Vehículos',
      description: 'Camionetas y vehículos que retiran combustible',
      icon: <VehiculosIcon />,
      isAvailable: canAccessVehiculos,
      onClick: () => navigate('/admin/vehiculos')
    },
    {
      id: 'tarjetas',
      title: t('admin.tarjetas'),
      description: t('admin.tarjetas_desc'),
      icon: <TarjetasIcon />,
      isAvailable: canAccessTarjetas,
      onClick: () => navigate('/admin/tarjetas')
    },
    {
      id: 'emisores',
      title: t('admin.emisores'),
      description: t('admin.emisores_desc'),
      icon: <EmisoresIcon />,
      isAvailable: canAccessEmisores,
      onClick: () => navigate('/admin/emisores')
    },
    {
      id: 'items-chequeo',
      title: t('admin.checklist'),
      description: t('admin.checklist_desc'),
      icon: <ItemsChequeoIcon />,
      isAvailable: canAccessItemsChequeo,
      onClick: () => navigate('/admin/items-chequeo')
    },
    {
      id: 'usuarios-maquinas',
      title: t('admin.user_machines'),
      description: t('admin.user_machines_desc'),
      icon: <UsuariosMaquinasIcon />,
      isAvailable: canAccessUserControlMaquinas,
      onClick: () => navigate('/admin/usuarios-maquinas')
    },
    {
      id: 'usuarios-operadores',
      title: t('admin.user_operators'),
      description: t('admin.user_operators_desc'),
      icon: <UsuariosOperadoresIcon />,
      isAvailable: canAccessUserControlOperadores,
      onClick: () => navigate('/admin/usuarios-operadores')
    },
    {
      id: 'configuracion',
      title: t('admin.settings.title'),
      description: t('admin.settings.card_description'),
      icon: <ConfiguracionIcon />,
      isAvailable: canAccessConfiguracion,
      onClick: () => navigate('/admin/configuracion')
    }
  ], [t, canAccessMaquinas, canAccessOperadores, canAccessFaenas, canAccessCalificadores,
      canAccessPredios, canAccessRodales, canAccessInsumos, canAccessProveedores, canAccessVehiculos, canAccessTarjetas, canAccessEmisores, canAccessItemsChequeo,
      canAccessUserControlMaquinas, canAccessUserControlOperadores, canAccessConfiguracion, navigate]);

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">{t('admin.title')}</h1>
          <p className="text-gray-600 mt-1">{t('admin.title')}</p>
        </div>
        <button
          onClick={() => navigate('/dashboard')}
          className="bg-gray-500 hover:bg-gray-600 text-white px-4 py-2 rounded-lg text-sm font-medium transition-colors duration-200 flex items-center space-x-2"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
          </svg>
          <span>{t('common.back')}</span>
        </button>
      </div>

      {/* Estadísticas de empresa */}
      {estadisticas?.estadisticas && (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          <Card className="text-center" padding="md">
            <div className="text-2xl font-bold text-blue-600">{estadisticas.estadisticas.operadores || 0}</div>
            <div className="text-sm text-gray-600">{t('admin.operators')}</div>
          </Card>
          <Card className="text-center" padding="md">
            <div className="text-2xl font-bold text-green-600">{estadisticas.estadisticas.faenas || 0}</div>
            <div className="text-sm text-gray-600">{t('admin.faenas')}</div>
          </Card>
          <Card className="text-center" padding="md">
            <div className="text-2xl font-bold text-purple-600">{estadisticas.estadisticas.maquinas || 0}</div>
            <div className="text-sm text-gray-600">{t('admin.machines')}</div>
          </Card>
          <Card className="text-center" padding="md">
            <div className="text-2xl font-bold text-orange-600">{estadisticas.estadisticas.insumos || 0}</div>
            <div className="text-sm text-gray-600">{t('admin.supplies')}</div>
          </Card>
        </div>
      )}

      {/* Grid de secciones administrativas */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {adminSections.map((section) => (
          <AdminCard
            key={section.id}
            title={section.title}
            description={section.description}
            icon={section.icon}
            isAvailable={section.isAvailable}
            onClick={section.onClick}
          />
        ))}
      </div>

    </div>
  );
};

export default AdminView;
